import { cn, shortDateTime } from '@/renderer/lib/utils';
import { SalesOrderItem } from '@/renderer/types/order';
import { Clock3 } from 'lucide-react';
import React from 'react';

interface OrderItemWrapperProps {
  item: SalesOrderItem;
  isSelected: boolean;
  onSelect: (itemId: string) => void;
}

export const OrderItemWrapper: React.FC<OrderItemWrapperProps> = ({
  item,
  isSelected,
  onSelect,
}) => {
  return (
    <button
      type="button"
      className={cn(
        'rounded border border-gray-200 p-3 text-black bg-white text-left',
        isSelected ? 'bg-pos-primary/90 text-white' : '',
      )}
      onClick={() => onSelect(item.id)}
      id={`split-item-${item.id}`}
    >
      <div className="flex justify-between items-center gap-3">
        <div className="flex items-start gap-2">
          <div className="space-y-1">
            <p className="text-sm font-semibold leading-none">
              ({item.quantity.toLocaleString()}) * {item.name}
            </p>
            <p className="flex items-center gap-1.5 text-[11px] font-medium">
              <span>KOT #{item.kot_id}</span>
              <span>•</span>
              <span>{item.status}</span>
              <span>•</span>
              <Clock3 size={11} />
              <span>{shortDateTime(item.created_at)}</span>
              {item.added_by_name ? (
                <>
                  <span>•</span>
                  <span>Added by {item.added_by_name}</span>
                </>
              ) : null}
            </p>
          </div>
        </div>
        <span className="flex gap-2 justify-center items-center">
          <p className="text-lg font-semibold leading-none">
            {item.amount.toLocaleString()}
          </p>
        </span>
      </div>
    </button>
  );
};
